// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import plugin from './components/';
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
Vue.config.productionTip = false
// 引入element-ui
import ElementUI from 'element-ui';

import 'lib-flexible'
// import VueRouter from 'vue-router'
import 'element-ui/lib/theme-chalk/index.css';
// import './../static/icon/iconfont.css'
// import './../static/css/pc.css'
import './../static/icon/iconfont.css'
Vue.use(ElementUI);
Vue.use(plugin);
// Vue.use(VueRouter);
// import paymentDetail from './components/page/paymentDetail'
import axios from 'axios';
axios.defaults.withCredentials = true;

import Qs from 'qs';
/* eslint-disable no-new */
import 'viewerjs/dist/viewer.css'
　　import Viewer from 'v-viewer'
　　Vue.use(Viewer)

if (process.env.NODE_ENV === "development") {
	console.log("development")
	 Vue.prototype.host = '/npl';
} else {
	console.log("production")
	//钛客云后台管理系统--正式
	Vue.prototype.host = '/npl';
}
//钛客云后台管理系统--正式
// Vue.prototype.host = '/npl';
// Vue.prototype.host = 'http://www.hzyhamc.com/npl';
// Vue.prototype.host = '/npl-test';

// const routes = [
// 	{path:'/paymentDetail',component:paymentDetail}
// ]
// const router = new VueRouter({
// 	mode:'history',
// 	routes
// })
//封装ajax
Vue.prototype.ajaxJson = function(options) {
  let that = this;
	if (options.data) {
		// options.data.appId = that.$store.state.id;
		// options.data.appId = that.localData('get', 'roleId');
		// options.data.appId = that.$store.state.id;
		// if (
		//   options.data.hasOwnProperty('name') &&
		//   options.data.hasOwnProperty('password')
		// ) {
		//   options.data.appId = null;
		// }
	}
	axios({
		// url: options.url,
		url: this.host + options.url,
		method: options.method ? options.method : 'POST',
		headers: options.headers,
		data: options.data,
		params: options.params,
		withCredentials: true,
		// headers: { 'X-Requested-With': 'XMLHttpRequest' }
	})
		.then(
			function(res) {
				if (res.status == 200) {
					options.success(res.data);
					let code = res.data.code;
					if (code != '0') {
						// that.$message.error(res.data.message);
						if (code == '1003') {
							that.logout();
						}
	
						if (code == '500') {
							that.logout();
						}
					}
				}
				if (res.status == 302) {
					console.info('302');
				}
			}
		)
		.catch(function(error) {
			if (error.response) {
				let code = error.response.status;
				if (code == '404') {
					that.$message.error('接口不存在');
					options.success({});
				} else {
					that.$message.error('登录过期,请重新登录!');
					that.$router.push({path:'/'})
					options.success({});
				}
			}
		});
};
Vue.prototype.formatter_time = function(cellValue) {
	return cellValue ? new Date(cellValue).Format('yyyy-MM-dd') : '--';
};
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js